import {PUBLISHED, UNPUBLISHED} from '@/utils/constants/jobs';

export default {
  loading: null,
  [PUBLISHED]: [],
  [UNPUBLISHED]: [],
  meta: null,
  error: null
};
